import t from "./translate";

export default function getBundleByDate(offerType) {
  const schedule = JSON.parse(t("UNI_OFFERS_SCHEDULE"));
  // Current eastern time in this format: "2/3/2024, 3:24:00 AM"
  const currentDateTime = new Date().toLocaleString("en-US", {
    timeZone: "America/New_York"
  });
  const currentDateKey = currentDateTime.split(",")[0];
  const bundleId = schedule[offerType][currentDateKey];

  return bundleId;
}
